import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)
// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/ApplyNow/applicantHome.vue'),
    meta: {
      title: 'eassist'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue'),
    meta: {
      title: 'login'
    }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/User.vue'),
    meta: {
      title: 'user'
    }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('../views/Apply.vue'),
    meta: {
      title: 'apply'
    }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/ApplyNow/Service.vue'),
    meta: {
      title: 'service'
    }
  },
  {
    path: '/position',
    name: 'position',
    component: () => import('../views/ApplyNow/Position.vue'),
    meta: {
      title: 'position'
    }
  },
  {
    path: '/ohodonticTest',
    name: 'ohodonticTest',
    component: () => import('../views/ApplyNow/OhodonticTest.vue'),
    meta: {
      title: 'ohodonticTest'
    }
  },
  {
    path: '/medicalBillingTest',
    name: 'medicalBillingTest',
    component: () => import('../views/ApplyNow/medicalBillingTest.vue'),
    meta: {
      title: 'medicalBillingTest'
    }
  },
  {
    path: "/insuranceVerificationTest",
    name: 'insuranceVerificationTest',
    component: () => import('../views/ApplyNow/insuranceVerificationTest.vue'),
    meta: {
      title: 'insuranceVerificationTest'
    }
  },
  {
    path: "/oralSurgeryTest",
    name: 'oralSurgeryTest',
    component: () => import('../views/ApplyNow/oralSurgeryTest.vue'),
    meta: {
      title: 'oralSurgeryTest'
    }
  },
  {
    path:'/oralSurgeryTest1',
    name:'oralSurgeryTest1',
    component: () => import('../views/newOrientation/oralSurgeryTest.vue'),
    meta: {
      title: 'oralSurgeryTest'
    }
  },
  {
    path: "/dentalBillingTest",
    name: 'dentalBillingTest',
    component: () => import('../views/ApplyNow/dentalBillingTest.vue'),
    meta: {
      title: 'dentalBillingTest'
    }
  },
  {
    path:'/dentalAccountingTest',
    name: 'dentalAccountingTest',
    component: () => import('../views/newOrientation/dentalAccounting.vue'),
    meta: {
      title: 'dentalAccountingTest'
    }
  },
  {
    path:'/dentalAccountingV2Test',
    name: 'dentalAccountingV2Test',
    component: () => import('../views/newOrientation/dentalAccountingV2.vue'),
    meta: {
      title: 'dentalAccountingV2Test'
    }
  },
  {
    path: "/colorTest",
    name: "colorTest",
    component: () => import('../views/ApplyNow/colorTest.vue'),
    meta: {
      title: 'colorTest'
    }
  },
  {
    path: "/colorChart",
    name: "colorChart",
    component: () => import('../views/ApplyNow/colorChart.vue'),
    meta: {
      title: "colorChart"
    }
  },
  {
    path: "/hollandTest",
    name: "hollandTest",
    component: () => import('../views/ApplyNow/hollandTest.vue'),
    meta: {
      title: "hollandTest"
    }
  },
  {
    path: "/testBoard",
    name: "testBoard",
    component: () => import('../views/ApplyNow/testBoard.vue'),
    meta: {
      title: "testBoard"
    }
  },
  //新的whatif页面
  {
    path:'/newWhatIf',
    name:'newWhatIf',
    component: () => import('../views/newOrientation/whatIf.vue'),
    meta: {
      title: "newWhatIf"
    }
  },
  //v4版本whatif
  {
    path:'/whatIfv4',
    name:'whatIfv4',
    component: () => import('../views/newOrientation/whatIfv4.vue'),
    meta: {
      title: "WhatIf"
    }
  },
  {
    path: "/resiliencyBoard",
    name: "resiliencyBoard",
    component: () => import('../views/ApplyNow/resiliencyBoard.vue'),
    meta: {
      title: "resiliencyBoard"
    }
  },
  {
    path: "/abilityBoard",
    name: "abilityBoard",
    component: () => import('../views/ApplyNow/abilityBoard.vue'),
    meta: {
      title: "abilityBoard"
    }
  },
  {
    path: "/applicantHome",
    name: 'applicantHome',
    component: () => import('../views/ApplyNow/applicantHome.vue'),
    meta: {
      title: 'applicantHome'
    }
  },
  {
    path: "/selectApplyPage",
    name: 'selectApplyPage',
    component: () => import('../views/selectApplyPage.vue'),
    meta: {
      title: 'select'
    }
  },
  {
    path: "/loginToken",
    name: 'loginToken',
    component: () => import('../views/loginToken.vue'),
    meta: {
      title: 'loginToken'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
